<template lang="pug">
  .b-change {{ change.info.new ? 'Задача закрыта' : 'Задача открыта' }}
</template>

<script>
export default {
  name: 'TaskChangeClosure',
  props: {
    change: Object,
  },
};
</script>

<style scoped lang="scss">

</style>
